import { useQuery } from "@tanstack/react-query";
import { CATEGORY_URL } from "../util/constants";
import useApi from "./useApi";
import Category from "../interfaces/category";

const useCategory = () => {
    const { recover } = useApi<Category[]>(`${CATEGORY_URL}`);

    return useQuery({
        queryKey: ["categories"],
        queryFn: () => recover()
    });
};

export default useCategory;